class SwiperSlider extends HTMLElement {
  constructor() {
    super();
    this.disabled_desktop = this.dataset.disabledDesktop === "true";
    this.swiper = this.querySelector(".swiper");
    this.params = JSON.parse(this.dataset.params);
    this.swiperParse = null;
  }
  connectedCallback() {
    this.initSwiper();
    window.addEventListener("resize", () => this.initSwiper());
  }
  initSwiper() {
    if (this.disabled_desktop) {
      if (window.innerWidth < 1024 && !this.swiperParse) {
        this.swiperParse = new Swiper(this.swiper, this.params);
      }
      
      else if (window.innerWidth >= 1024 && this.swiperParse) {
        this.swiperParse.destroy(true, true);
        this.swiperParse = null;
      }
    } else {
      if (!this.swiperParse) {
        this.swiperParse = new Swiper(this.swiper, this.params);
      }
    }
  }
}

customElements.define("swiper-slider", SwiperSlider);


class FcHomepageSection2 extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll(".fc-homepage-section-2__tab");
    this.panels = this.querySelectorAll(".fc-homepage-section-2__products");

    this.tabs.forEach((tab) => {
      tab.addEventListener("click", () => this.switchTab(tab));
    });
  }

  switchTab(activeTab) {
    var target = activeTab.dataset.target;
    var self = this;

    if (this._switching) return;
    this._switching = true;

    this.tabs.forEach(function (tab) {
      var isActive = tab.dataset.target === target;
      tab.classList.toggle("fc-homepage-section-2__tab--active", isActive);
      tab.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    var currentPanel = this.querySelector(".fc-homepage-section-2__products:not(.fc-homepage-section-2__products--hidden)");
    var nextPanel = this.querySelector('.fc-homepage-section-2__products[data-tab="' + target + '"]');

    if (currentPanel === nextPanel) {
      this._switching = false;
      return;
    }

    /* Fade out current panel */
    currentPanel.classList.add("fc-homepage-section-2__products--fade-out");

    var onFadeOut = function () {
      currentPanel.removeEventListener("transitionend", onFadeOut);
      currentPanel.classList.add("fc-homepage-section-2__products--hidden");
      currentPanel.classList.remove("fc-homepage-section-2__products--fade-out");

      /* Prepare next panel: visible but transparent */
      nextPanel.classList.remove("fc-homepage-section-2__products--hidden");
      nextPanel.classList.add("fc-homepage-section-2__products--fade-out");

      /* Re-init swiper for the incoming panel */
      var slider = nextPanel.querySelector("swiper-slider");
      if (slider && slider.swiperParse) {
        slider.swiperParse.destroy(true, true);
        slider.swiperParse = null;
      }
      if (slider) {
        slider.initSwiper();
      }

      /* Force reflow then fade in */
      void nextPanel.offsetWidth;
      nextPanel.classList.remove("fc-homepage-section-2__products--fade-out");
      nextPanel.classList.add("fc-homepage-section-2__products--fade-in");

      var onFadeIn = function () {
        nextPanel.removeEventListener("transitionend", onFadeIn);
        nextPanel.classList.remove("fc-homepage-section-2__products--fade-in");
        self._switching = false;
      };
      nextPanel.addEventListener("transitionend", onFadeIn);
    };

    currentPanel.addEventListener("transitionend", onFadeOut);
  }
}
customElements.define("fc-homepage-section-2", FcHomepageSection2);
